import LazyloadHelper from './LazyloadHelper';
import { breakpoints } from '../constants';
// @snippet
/**
 * @class Picture
 */

const defaultOptions = {
  lazyload: true,
  cropType: 'crop_center',
};

class Picture {
  constructor() {}
  static render(data, options = defaultOptions) {
    options = { ...defaultOptions, ...options };
    const { sizes, size_default, alt, loadElement, url } = data;
    const { cropType, lazyload } = options;

    const setSourceParams = (size) => {
      const width = size.split('x')[0] || null;
      const height = size.split('x')[1] || null;
      const data = {
        width,
        height,
      };
      const regex = /([^\/]+$)/gm;

      const filename = url.match(regex)[0];
      // const extension = filename.split(/[#?]/)[0].split('.').pop().trim();
      // console.log('xxx', filename, extension)
      const size_x1 =
        filename.substring(0, filename.lastIndexOf('.')) +
        '_' +
        size +
        `_${cropType}` +
        filename.substring(filename.lastIndexOf('.'));
      const size_x2 =
        filename.substring(0, filename.lastIndexOf('.')) +
        '_' +
        size +
        `_${cropType}` +
        '@2x' +
        filename.substring(filename.lastIndexOf('.'));

      const url_x1 = url.replace(filename, size_x1).trim();
      const url_x2 = url.replace(filename, size_x2).trim();

      let src = url_x1 ? `${url_x1.trim()}` : url;
      if (url_x2) {
        src = `${url_x2} x2, ${src} x1`;
      }

      data['src'] = src;
      data['srcSet'] = `${url_x2.trim()} 2x, ${url_x1.trim()} 1x`;

      return data;
    };

    const renderSize = (sizeKey, sort_sizes) => {
      const params = setSourceParams(sort_sizes[sizeKey]);
      const props = {
        srcSet: lazyload ? '#' : params.srcSet,
        width: params.width,
        height: params.height,
        media: `(min-width: ${breakpoints[sizeKey]}px)`,
      };
      if (lazyload) {
        props['data-srcset'] = params.srcSet;
      }
      const source = document.createElement('source');
      Object.keys(props).forEach((key) => {
        source.setAttribute(key, props[key]);
      });
      return source;
    };

    const renderImg = (size_default) => {
      const params = setSourceParams(size_default);
      const props = {
        src: lazyload ? '#' : params.src,
        width: params.width,
        height: params.height,
        alt,
      };
      if (lazyload) {
        props['data-src'] = params.src.split(' ')[0].trim();
        props['data-srcSet'] = params.src.trim();
        props['loading'] = 'lazy';
        // props['srcSet'] = params.srcSet.trim()
      } else if (sizes) {
        props['srcSet'] = params.srcSet.trim();
      }
      const img = document.createElement('img');
      Object.keys(props).forEach((key) => {
        img.setAttribute(key, props[key]);
      });
      return img;
    };

    const wrapper = document.createElement('picture');
    if (lazyload) {
      wrapper.dataset.imageState = 'waiting';
    }

    if (sizes) {
      const sort_keys = Object.keys(breakpoints);
      const sort_sizes = {};
      sort_keys.reverse().forEach((size_key) => {
        if (sizes[size_key]) {
          sort_sizes[size_key] = sizes[size_key];
        }
      });

      Object.keys(sort_sizes).map((sizeKey) => {
        wrapper.appendChild(renderSize(sizeKey, sort_sizes));
      });
    }
    wrapper.appendChild(renderImg(size_default));

    if (loadElement) {
      LazyloadHelper.load(wrapper);
    } else if (lazyload && window.LazyLoaderRun && wrapper) {
      window.LazyLoaderRun([wrapper]);
    }
    return wrapper;
  }

  static imageUrl(image, size) {
    const regex = /([^\/]+$)/gm;
    const filename = image.src.match(regex)[0];
    const filename_size =
      filename.substring(0, filename.lastIndexOf('.')) +
      '_' +
      size +
      filename.substring(filename.lastIndexOf('.'));
    const url = image.src.replace(filename, filename_size);

    return url;
  }
}
export default Picture;
